'use client'
import {
  createProductItemHref,
  isResellProduct,
  resolveProductEventType,
  resolveProductUrlType
} from "./chunk-NY6K524K.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/util/events.ts
var resolveContentfulEventType = (item) => {
  switch (item == null ? void 0 : item.__typename) {
    case "Product":
      return resolveProductUrlType(item.entityType);
    case "Zone":
      return "zones";
    case "Category":
      return "explore";
    case "WebPage":
      return "page";
    case "Season":
      return "season";
    default:
      return null;
  }
};
var createSectionItemHref = (item) => {
  var _a, _b, _c, _d, _e;
  const urlType = resolveContentfulEventType(item);
  const safeUrlType = urlType ? `/${urlType}/` : "/";
  const cleanSlug = ((_a = item.slug) == null ? void 0 : _a.startsWith("/")) ? item.slug.slice(1) : item.slug;
  if (urlType === "page") {
    return `${safeUrlType}${cleanSlug}`;
  }
  const country = (_b = item.location) == null ? void 0 : _b.countryCode;
  if (!country) {
    return `${safeUrlType}${cleanSlug}`;
  }
  let href = `/${country}`;
  if ((_c = item.location) == null ? void 0 : _c.cityCode) {
    href += `/${item.location.cityCode}`;
  }
  if ((_d = item.category) == null ? void 0 : _d.slug) {
    if (!((_e = item.location) == null ? void 0 : _e.cityCode)) href += "/local";
    href += `/${item.category.slug}`;
    return `${href}${safeUrlType}${cleanSlug}`;
  }
  href += safeUrlType + cleanSlug;
  return href;
};
var parseProductToCardItem = (product) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return __spreadProps(__spreadValues({}, product), {
    image11: (_a = product.kv) == null ? void 0 : _a.image11,
    image31: (_b = product.kv) == null ? void 0 : _b.image31,
    image32: (_c = product.kv) == null ? void 0 : _c.image32,
    startingPrice: (_d = product.action) == null ? void 0 : _d.startingPrice,
    discountedPrice: (_e = product.action) == null ? void 0 : _e.discountedPrice,
    currencyCode: (_f = product.action) == null ? void 0 : _f.currencyCode,
    prefix: (_g = product.action) == null ? void 0 : _g.prefix,
    buttonLabel: (_h = product.action) == null ? void 0 : _h.title,
    eventType: resolveProductEventType(product.action),
    isComingSoon: ((_i = product.action) == null ? void 0 : _i.type) === "coming_soon",
    isStreamingEvent: !!product.stream,
    showResellBanner: isResellProduct(product.action)
  });
};
var parseSectionItem = ({
  item,
  locale
}) => {
  var _a, _b, _c, _d, _e;
  const type = item == null ? void 0 : item.__typename;
  switch (type) {
    case "Product": {
      const card = parseProductToCardItem(item);
      return __spreadProps(__spreadValues({}, card), {
        href: `/${locale}${createProductItemHref(item)}`,
        label: card.buttonLabel,
        date: (_a = item.schedule) == null ? void 0 : _a.openScheduleText,
        background: card.image31
      });
    }
    case "WebCard":
      return __spreadProps(__spreadValues({}, item), {
        href: ((_b = item == null ? void 0 : item.href) == null ? void 0 : _b.startsWith("http")) ? item.href : item.href ? `/${locale}${createSectionItemHref(__spreadProps(__spreadValues({}, item), {
          // for safety, href can have `/locale` in the slug, remove it
          slug: ((_c = item.href) == null ? void 0 : _c.startsWith(`/${locale}`)) ? item.href.slice(locale.length + 1) : item.href || ""
        }))}` : "",
        label: item.buttonLabel,
        image31: item.image31 || item.image,
        image11: item.image11 || item.image,
        background: item.image,
        isNew: item.isNew
      });
    case "Zone":
      return __spreadProps(__spreadValues({}, item), {
        label: (_d = item.button) == null ? void 0 : _d.label,
        date: (_e = item.schedule) == null ? void 0 : _e.openScheduleText,
        image31: item.banner || item.featuredBanner,
        image11: item.featuredBanner,
        href: `/${locale}${createSectionItemHref(item)}`,
        background: item.imageBg,
        eventType: "internal"
      });
    case "Category":
      return __spreadProps(__spreadValues({}, item), {
        href: `/${locale}/explore?category=${item.slug}`,
        image31: item.background || item.icon,
        image11: item.background || item.icon,
        icon: item.icon,
        isNew: item.isNew
      });
    case "Tag":
      return __spreadProps(__spreadValues({}, item), {
        href: `/${locale}/explore?tag=${item.slug}`,
        image31: item.background,
        image11: item.background,
        icon: item.icon,
        isNew: item.isNew
      });
    // case 'WebPage':
    //   return {
    //     ...item,
    //     href: `/${locale}${createSectionItemHref(item)}`,
    //   };
    // case 'Season':
    //   return {
    //     ...item,
    //     href: `/${locale}${createSectionItemHref(item)}`,
    //   };
    default:
      return null;
  }
};
var parseCardItem = ({
  item
}) => {
  const type = item == null ? void 0 : item.__typename;
  switch (type) {
    case "Product":
      return parseProductToCardItem(item);
    case "Zone":
      return __spreadProps(__spreadValues({}, item), {
        image11: item.featuredBanner,
        image31: item.banner || item.featuredBanner,
        image32: item.banner || item.featuredBanner
      });
    case "Season":
      return __spreadProps(__spreadValues({}, item), {
        image11: item.image11 || item.background,
        image31: item.image31 || item.background,
        image32: item.image11 || item.background
      });
    case "WebPage":
      return __spreadProps(__spreadValues({}, item), {
        image11: item.image11 || item.background,
        image31: item.image31 || item.background,
        image32: item.image11 || item.background
      });
    default:
      return null;
  }
};

export {
  resolveContentfulEventType,
  createSectionItemHref,
  parseSectionItem,
  parseCardItem
};
//# sourceMappingURL=chunk-DJNQ4XY4.mjs.map